export default {
  'Rating.Star': ({ currentStar }, outlet) => {
    outlet({ rating: currentStar })
  }
};
